import bor_borito from './bor_borito.json';
import canvas_dream from './canvas_dream.json';
import dekor_borito from './dekor_borito.json';
import finessa from './finessa.json';
import fotos_borito from './fotos_borito.json';
import wedding_sensation from './wedding_sensation.json';
import calligrafia from './calligrafia.json';
import init from './../../cover_template.json';

export default {
  bor_borito,
  canvas_dream,
  dekor_borito,
  finessa,
  fotos_borito,
  wedding_sensation,
  calligrafia,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/pro/portrait/index.jsx